<template>
  <div v-if="!loading">
    {{ prisoner.base_number }} {{ prisoner.gender }} {{ prisoner.birth_date }}
  </div>
  <div v-else>
    <v-skeleton-loader
      class="mx-auto"
      type="text"
    />
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();

export default {
  name: "GeneralInfo",

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    loading: true,
    prisoner: null,
  }),

  watch: {},
  created() {
    this.getData(this.id);
  },

  methods: {
    getData(id) {
      this.loading = true;
      apiService.getPrisoner(id).then((response) => {
        this.prisoner = response;
        this.loading = false;
      });
    },
  },
};
</script>